import { IconProps } from 'types/icon.type'

export const FilterIcon = (props: IconProps) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Filter icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.125 5C2.125 4.65482 2.40482 4.375 2.75 4.375H17.75C18.0952 4.375 18.375 4.65482 18.375 5C18.375 5.34518 18.0952 5.625 17.75 5.625H2.75C2.40482 5.625 2.125 5.34518 2.125 5ZM5.45833 10C5.45833 9.65482 5.73816 9.375 6.08333 9.375H14.4167C14.7618 9.375 15.0417 9.65482 15.0417 10C15.0417 10.3452 14.7618 10.625 14.4167 10.625H6.08333C5.73816 10.625 5.45833 10.3452 5.45833 10ZM7.95833 15C7.95833 14.6548 8.23816 14.375 8.58333 14.375H11.9167C12.2618 14.375 12.5417 14.6548 12.5417 15C12.5417 15.3452 12.2618 15.625 11.9167 15.625H8.58333C8.23816 15.625 7.95833 15.3452 7.95833 15Z"
        fill="currentColor"
      />
    </svg>
  )
}
